import TickerTape from "./Widgets/TickerTape";

function Header() {
  return(
    <div>
      <TickerTape />
    </div>
  )
}

export default Header;